import type {TypedSchema} from 'schemaDefinition/types';
import type {BulkUpdateSummary} from 'services/bulkUpdates/types';
import {bulkUpdateCreateStaticSchema} from './bulkUpdateSchemas';

export const bulkUpdateSummarySchema: TypedSchema<BulkUpdateSummary> = {
  name: 'bulkUpdateSummary',
  parts: [
    {
      name: 'created',
      type: 'date',
    },
    {
      name: 'completed',
      type: 'date',
    },
    {
      type: 'codelist',
      name: 'status',
      codelistId: 'bulkUpdateStatus',
    },
    {
      name: 'type',
      type: 'codelist',
      codelistId: 'bulkUpdateType',
    },
    ...bulkUpdateCreateStaticSchema.parts,
    {
      name: 'currentValues',
      type: 'text',
    },
    {
      name: 'newValues',
      type: 'text',
    },
    {
      name: 'succeeded',
      type: 'int',
    },
    {
      name: 'failed',
      type: 'int',
    },
    {
      name: 'unprocessed',
      type: 'int',
    },
  ],
};
